@if (visible) {
  <span
    class="annex-imported-badge"
    [matTooltip]="'Annex.Imported' | translate"
    matTooltipClass="annex-badge-tooltip"
  >i</span>
}
